import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import CircularSpinner from '../components/UI/Progress/CircularSpinner';
import logo from '../public/images/logo/logo-800x800.webp';

const PREFIX = 'Loading';

const classes = {
	Loading: `${PREFIX}-Loading`,
	Logo: `${PREFIX}-Logo`
};

const StyledTypography = styled(Typography)(({ theme }) => ({
	[`&.${classes.Loading}`]: {
		height: '100vh',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexFlow: 'column'
	},

	[`& .${classes.Logo}`]: {
		height: '150px',
		marginBottom: '10px'
	}
}));

function Loading() {
	return (
		<StyledTypography component="div" className={classes.Loading}>
			<img src={logo} className={classes.Logo} alt="logo" />
			<CircularSpinner />
		</StyledTypography>
	);
}

export default Loading;
